module.exports = __webpack_public_path__ + "static/media/sonomeamarelo.fcc5254c.png";